module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "password-checker-haveibeenpwned.c22ad4ce.png" + "?" + Date.now();